import React, { useEffect, useState, useContext } from 'react';
import { ArrowRightIcon, BellIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, FileTextIcon, DollarSignIcon, PencilRulerIcon, CalendarIcon, SearchIcon, ChevronRightIcon, RefreshCwIcon, BarChart3Icon, TrendingUpIcon, UsersIcon, LayoutDashboardIcon, ZapIcon, StarIcon, ShieldIcon } from 'lucide-react';
import { FairContext } from '../contexts/FairContext';
import { FairPromotion } from '../components/FairPromotion';
export function HomePageAlternative2({
  onNavigate
}) {
  const {
    activeFair,
    setActiveFair
  } = useContext(FairContext);
  const [showPromotion, setShowPromotion] = useState(true);
  // Add an effect to log when the active fair changes
  useEffect(() => {
    if (activeFair && activeFair.hasQRCode) {
      console.log('Home page detected active fair with QR:', activeFair);
      setShowPromotion(true);
    }
  }, [activeFair]);
  const handleClosePromotion = () => {
    setShowPromotion(false);
  };
  // Mock data for alerts and pending orders
  const alerts = [{
    id: 1,
    type: 'order',
    title: 'New order received',
    description: 'Order #HX6AA6-3 received from AiscoEurope SAU',
    time: '10 minutes',
    priority: 'high'
  }, {
    id: 2,
    type: 'quote',
    title: 'Quote pending approval',
    description: 'Quote #DKEYFH-1 awaiting approval',
    time: '2 hours',
    priority: 'medium'
  }, {
    id: 3,
    type: 'design',
    title: 'Design shared',
    description: 'Daniel Fernández shared a design with you',
    time: '1 day',
    priority: 'low'
  }, {
    id: 4,
    type: 'quote',
    title: '3 new quotes created',
    description: 'New quotes have been created in the last 24 hours',
    time: '5 hours',
    priority: 'medium'
  }, {
    id: 5,
    type: 'quote',
    title: '4 quotes expiring soon',
    description: 'Quotes that will expire in the next 7 days',
    time: '1 day',
    priority: 'high'
  }];
  const pendingOrders = [{
    id: 'HX6AA6-3',
    customer: 'AiscoEurope SAU',
    product: 'Pivot Machine 8" 5/8 GALV',
    amount: '€80,108.29',
    status: 'pending',
    date: 'Jun 13, 2025'
  }, {
    id: 'DKEYFH-1',
    customer: 'HMB Irrigation',
    product: 'Reeltown 1058 ft wiper',
    amount: '$64,699.26',
    status: 'review',
    date: 'Jul 21, 2025'
  }, {
    id: 'T55NVQ',
    customer: 'HMB Irrigation',
    product: 'Pivot CP600',
    amount: '€72,350.00',
    status: 'approved',
    date: 'Jul 12, 2025'
  }];
  // Stats data
  const stats = [{
    title: 'Quotes',
    value: '12',
    change: '+3',
    icon: <FileTextIcon size={20} className="text-white" data-id="element-9391" />,
    color: 'from-blue-600 to-blue-800'
  }, {
    title: 'Designs',
    value: '8',
    change: '+2',
    icon: <PencilRulerIcon size={20} className="text-white" data-id="element-9392" />,
    color: 'from-blue-500 to-indigo-700'
  }, {
    title: 'Orders',
    value: '5',
    change: '+1',
    icon: <CheckCircleIcon size={20} className="text-white" data-id="element-9393" />,
    color: 'from-indigo-600 to-blue-900'
  }, {
    title: 'Clients',
    value: '24',
    change: '+4',
    icon: <UsersIcon size={20} className="text-white" data-id="element-9394" />,
    color: 'from-blue-700 to-indigo-800'
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9395">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-9396">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9397"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-indigo-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9398"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-9399"></div>
      </div>
      {/* Main content */}
      <div className="relative z-10 flex-1" data-id="element-9400">
        {/* Fair Promotion Banner (if there's an active fair with QR) */}
        {activeFair && activeFair.hasQRCode && showPromotion && <div className="px-6 md:px-12 pt-6" data-id="element-9401">
            <FairPromotion fair={activeFair} onClose={handleClosePromotion} data-id="element-9402" />
          </div>}
        {/* Header with welcome section */}
        <div className="px-6 md:px-12 pt-16 pb-12 max-w-7xl mx-auto" data-id="element-9403">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-9404">
            <div className="text-center md:text-left" data-id="element-9405">
              <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-indigo-200 mb-4" data-id="element-9406">
                Welcome back, Alex
              </h1>
              <p className="text-xl text-blue-100 max-w-xl" data-id="element-9407">
                Here's your simplified dashboard with alerts and pending orders
              </p>
            </div>
            <div className="flex space-x-4" data-id="element-9408">
              <button onClick={() => onNavigate('dashboard')} className="flex items-center px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-blue-800/30 rounded-xl text-white transition-all" data-id="element-9409">
                <LayoutDashboardIcon size={18} className="mr-2" data-id="element-9410" />
                Dashboard
              </button>
              <button onClick={() => onNavigate('design')} className="flex items-center px-5 py-2.5 bg-gradient-to-r from-blue-600/80 to-indigo-600/80 hover:from-blue-600 hover:to-indigo-600 border border-blue-500/30 rounded-xl text-white transition-all" data-id="element-9411">
                <PencilRulerIcon size={18} className="mr-2" data-id="element-9412" />
                New Design
              </button>
            </div>
          </div>
        </div>
        {/* Stats cards */}
        <div className="px-6 md:px-12 pb-12 max-w-7xl mx-auto" data-id="element-9413">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9414">
            {stats.map((stat, index) => <div key={index} className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:translate-y-[-2px]" data-id="element-9415">
                <div className={`bg-gradient-to-r ${stat.color} p-5`} data-id="element-9416">
                  <div className="flex justify-between items-center" data-id="element-9417">
                    <div data-id="element-9418">
                      <h3 className="text-sm font-medium text-white/80" data-id="element-9419">
                        {stat.title}
                      </h3>
                      <p className="text-3xl font-bold text-white mt-1" data-id="element-9420">
                        {stat.value}
                      </p>
                    </div>
                    <div className="bg-white/20 p-2.5 rounded-xl" data-id="element-9421">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="flex items-center text-sm text-white/80 mt-3" data-id="element-9422">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-9423" />
                    <span className="font-medium text-white" data-id="element-9424">
                      {stat.change}
                    </span>
                    <span className="ml-1" data-id="element-9425">this week</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Alerts and pending orders section */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto" data-id="element-9426">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-9427">
            {/* Alerts section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9428">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9429">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9430">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9431">
                    <BellIcon size={20} className="text-white" data-id="element-9432" />
                  </div>
                  Recent Alerts
                </h2>
                <div className="flex items-center space-x-2" data-id="element-9433">
                  <div className="px-2.5 py-1 bg-blue-500/20 text-blue-300 text-xs font-medium rounded-full flex items-center" data-id="element-9434">
                    <AlertCircleIcon size={12} className="mr-1" data-id="element-9435" />4 quotes
                    expiring soon
                  </div>
                  <div className="px-2.5 py-1 bg-indigo-500/20 text-indigo-300 text-xs font-medium rounded-full flex items-center" data-id="element-9436">
                    <FileTextIcon size={12} className="mr-1" data-id="element-9437" />3 new quotes
                  </div>
                  <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9438">
                    View all
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-9439" />
                  </button>
                </div>
              </div>
              <div data-id="element-9440">
                {alerts.map(alert => <div key={alert.id} className="p-4 hover:bg-white/5 transition-colors border-b border-blue-800/30 last:border-0" data-id="element-9441">
                    <div className="flex items-start" data-id="element-9442">
                      <div className={`mt-1 p-2 rounded-xl ${alert.priority === 'high' ? 'bg-gradient-to-br from-blue-500/20 to-indigo-500/20' : alert.priority === 'medium' ? 'bg-gradient-to-br from-blue-500/20 to-teal-500/20' : 'bg-gradient-to-br from-indigo-500/20 to-blue-500/20'}`} data-id="element-9443">
                        {alert.type === 'order' ? <FileTextIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9444" /> : alert.type === 'quote' ? <DollarSignIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9445" /> : <PencilRulerIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9446" />}
                      </div>
                      <div className="ml-4 flex-1" data-id="element-9447">
                        <h3 className="text-white font-medium" data-id="element-9448">
                          {alert.title}
                        </h3>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9449">
                          {alert.description}
                        </p>
                        <div className="flex items-center mt-2 text-xs text-blue-300" data-id="element-9450">
                          <ClockIcon size={12} className="mr-1" data-id="element-9451" />
                          {alert.time} ago
                        </div>
                      </div>
                      <button className="text-blue-400 hover:text-white p-2 rounded-lg transition-colors hover:bg-white/10" data-id="element-9452">
                        <ArrowRightIcon size={16} data-id="element-9453" />
                      </button>
                    </div>
                  </div>)}
              </div>
              <div className="p-4 bg-white/5" data-id="element-9454">
                <button className="w-full flex items-center justify-center bg-white/10 hover:bg-white/20 text-white py-2.5 rounded-xl transition-all" data-id="element-9455">
                  <RefreshCwIcon size={16} className="mr-2" data-id="element-9456" />
                  Refresh alerts
                </button>
              </div>
            </div>
            {/* Pending orders section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9457">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9458">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9459">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9460">
                    <ClockIcon size={20} className="text-white" data-id="element-9461" />
                  </div>
                  Pending Orders
                </h2>
                <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9462">
                  View all
                  <ChevronRightIcon size={16} className="ml-1" data-id="element-9463" />
                </button>
              </div>
              <div className="p-4" data-id="element-9464">
                <div className="relative" data-id="element-9465">
                  <input type="text" placeholder="Search orders..." className="w-full bg-white/10 border border-blue-800/30 rounded-xl px-10 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-9466" />
                  <SearchIcon className="absolute left-3.5 top-3 text-blue-300" size={16} data-id="element-9467" />
                </div>
              </div>
              <div className="px-4" data-id="element-9468">
                {pendingOrders.map((order, index) => <div key={order.id} className={`p-4 rounded-xl mb-3 ${order.status === 'pending' ? 'bg-white/5 border border-blue-500/20' : order.status === 'review' ? 'bg-white/5 border border-indigo-500/20' : 'bg-white/5 border border-teal-500/20'}`} data-id="element-9469">
                    <div className="flex justify-between items-start" data-id="element-9470">
                      <div data-id="element-9471">
                        <div className="flex items-center" data-id="element-9472">
                          <span className="text-white font-medium" data-id="element-9473">
                            {order.customer}
                          </span>
                          <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-9474">
                            {order.id}
                          </span>
                        </div>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9475">
                          {order.product}
                        </p>
                        <div className="mt-2 flex items-center" data-id="element-9476">
                          <span className="text-lg font-bold text-white" data-id="element-9477">
                            {order.amount}
                          </span>
                          <span className="ml-3 text-xs text-blue-300 flex items-center" data-id="element-9478">
                            <CalendarIcon size={12} className="mr-1" data-id="element-9479" />
                            {order.date}
                          </span>
                        </div>
                      </div>
                      <div data-id="element-9480">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${order.status === 'pending' ? 'bg-blue-500/20 text-blue-300' : order.status === 'review' ? 'bg-indigo-500/20 text-indigo-300' : 'bg-teal-500/20 text-teal-300'}`} data-id="element-9481">
                          {order.status === 'pending' ? <>
                              <AlertCircleIcon size={12} className="mr-1" data-id="element-9482" />
                              Pending
                            </> : order.status === 'review' ? <>
                              <FileTextIcon size={12} className="mr-1" data-id="element-9483" />
                              In review
                            </> : <>
                              <CheckCircleIcon size={12} className="mr-1" data-id="element-9484" />
                              Approved
                            </>}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 flex justify-end" data-id="element-9485">
                      <button className="text-blue-300 hover:text-white transition-colors text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg flex items-center" data-id="element-9486">
                        View details
                        <ArrowRightIcon size={14} className="ml-1" data-id="element-9487" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        {/* Quick actions section */}
        <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto" data-id="element-9488">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-9489">
            <ZapIcon size={24} className="mr-2 text-blue-400" data-id="element-9490" />
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-9491">
            <button onClick={() => onNavigate('quotes')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9492">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9493">
                <DollarSignIcon size={24} className="text-white" data-id="element-9494" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9495">
                Create Quote
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9496">
                Generate a new quote for a customer
              </p>
            </button>
            <button onClick={() => onNavigate('design')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9497">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9498">
                <PencilRulerIcon size={24} className="text-white" data-id="element-9499" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9500">
                Design System
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9501">
                Create a new irrigation system design
              </p>
            </button>
            <button onClick={() => onNavigate('order')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9502">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9503">
                <FileTextIcon size={24} className="text-white" data-id="element-9504" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9505">
                View Orders
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9506">
                Check status of current orders
              </p>
            </button>
            <button onClick={() => onNavigate('business-intelligence')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9507">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9508">
                <BarChart3Icon size={24} className="text-white" data-id="element-9509" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9510">Analytics</h3>
              <p className="text-blue-200 text-sm" data-id="element-9511">
                View business intelligence reports
              </p>
            </button>
          </div>
        </div>
        {/* Quote Score Overview */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto mb-12" data-id="element-9512">
          <div className="flex justify-between items-center mb-6" data-id="element-9513">
            <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-9514">
              <StarIcon size={24} className="mr-2 text-blue-400" data-id="element-9515" />
              Quote Score Overview
            </h2>
            <button onClick={() => onNavigate('quotes')} className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9516">
              View all quotes
              <ChevronRightIcon size={16} className="ml-1" data-id="element-9517" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9518">
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9519">
              <div className="flex justify-between items-start" data-id="element-9520">
                <div data-id="element-9521">
                  <h3 className="text-white text-lg font-medium" data-id="element-9522">High Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9523">
                    Almost ready to close
                  </p>
                </div>
                <div className="bg-blue-500/30 p-2 rounded-lg" data-id="element-9524">
                  <StarIcon size={20} className="text-blue-300" data-id="element-9525" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9526">
                <div className="text-3xl font-bold text-white" data-id="element-9527">3</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9528">
                  quotes with score 80+
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9529">
              <div className="flex justify-between items-start" data-id="element-9530">
                <div data-id="element-9531">
                  <h3 className="text-white text-lg font-medium" data-id="element-9532">
                    Medium Score
                  </h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9533">Under evaluation</p>
                </div>
                <div className="bg-indigo-500/30 p-2 rounded-lg" data-id="element-9534">
                  <StarIcon size={20} className="text-indigo-300" data-id="element-9535" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9536">
                <div className="text-3xl font-bold text-white" data-id="element-9537">4</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9538">
                  quotes with score 50-79
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9539">
              <div className="flex justify-between items-start" data-id="element-9540">
                <div data-id="element-9541">
                  <h3 className="text-white text-lg font-medium" data-id="element-9542">Low Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9543">
                    Weak or uncertain
                  </p>
                </div>
                <div className="bg-teal-500/30 p-2 rounded-lg" data-id="element-9544">
                  <StarIcon size={20} className="text-teal-300" data-id="element-9545" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9546">
                <div className="text-3xl font-bold text-white" data-id="element-9547">1</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9548">
                  quotes with score below 50
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="mt-auto relative z-10 border-t border-blue-800/30 py-6 text-center text-blue-300 text-sm" data-id="element-9549">
        <p data-id="element-9550">© 2025 Aisco Irrigation Systems. All rights reserved.</p>
      </footer>
    </div>;
}